export const name = 'externalServices' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const ExternalServicesLoaderSymbol = Symbol('ExternalServicesLoader')
export const SSRServicesModuleLoaderSymbol = Symbol('SSRServicesModuleLoaderSymbol')
export const ServiceBundleLoaderSymbol = Symbol('ServiceBundleLoader')
